import { styled } from 'styled-components';

interface CoverProps {
    background?: string;
    height?: string;
}
type iconTypeProps ='square' | 'rectangle'
interface IconProps {
    type?: iconTypeProps;
}

interface ProductCardBoxProps {
    hasIcon: boolean;
}

export const MoreBox = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
`;

export const MoreBoxIcon = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(36, 42, 51, 0.95)'
    : 'rgba(255, 255, 255, 0.95)')};
    border-radius: 6px;
    transition: all 0.2s ease;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 2px 8px rgba(255, 255, 255, 0.06)'
    : '0 2px 8px rgba(224, 123, 45, 0.1)')};

    &:hover {
        background: ${({ theme }) => theme.colors.card.background};
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        transform: scale(1.05);
    }
`;

export const ActionsContainer = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    gap: 8px;
    opacity: 0;
    transform: translateY(-5px);
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 10;
`;

export const ActionButton = styled.button<{ $isDanger?: boolean }>`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => {
    if (props.$isDanger) return props.theme.colors.danger[500];
    return props.theme.mode === 'dark' ? 'rgba(36, 42, 51, 0.95)' : 'rgba(255, 255, 255, 0.95)';
  }};
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);

    &:hover {
        background: ${(props) => {
    if (props.$isDanger) return props.theme.colors.danger[600];
    return props.theme.colors.card.background;
  }};
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: scale(1.08);
    }

    &:active {
        transform: scale(0.95);
    }

    svg {
        color: ${(props) => {
    if (props.$isDanger) return '#fff';
    return props.theme.colors.text.primary;
  }};
    }
`;

export const ProductCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.3s ease;
    background: ${({ theme }) => theme.colors.card.background};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};

    &:hover {
        box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 8px 24px rgba(255, 255, 255, 0.08)'
    : '0 8px 24px rgba(224, 123, 45, 0.15)')};
        transform: translateY(-2px);
        border-color: ${({ theme }) => theme.colors.border.secondary};
    }

    &:hover ${ActionsContainer} {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
    }
`;

export const Cover = styled.div<CoverProps>`
    width: 100%;
    height: ${(props) => props.height || '200px'};
    overflow: hidden;
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
`;

export const ProductCardBox = styled.div<ProductCardBoxProps>`
    width: 100%;
    height: ${(props) => (props.hasIcon ? '150px' : 'auto')};
    background: ${({ theme }) => theme.colors.card.background};
    padding: ${(props) => (props.hasIcon ? '35px 16px 16px 16px' : '16px')};
    position: relative;
    min-height: 100px;
`;

export const Title = styled.h3`
    font-size: 15px;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.4;
    margin: 0 0 6px 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Subtitle = styled.p`
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0 0 8px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const Description = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.5;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const IconWrapper = styled.div<IconProps>`
    width: 56px;
    height: 56px;
    position: absolute;
    top: -28px;
    left: 16px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: ${({ theme }) => theme.colors.card.background};
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 4px 12px rgba(255, 255, 255, 0.06)'
    : '0 4px 12px rgba(224, 123, 45, 0.12)')};
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({ theme }) => theme.colors.card.background};
`;

export const IconAttachmentWrapper = styled.div<IconProps>`
    width: 36px;
    height: 36px;
    position: absolute;
    bottom: 12px;
    right: 12px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.85);
        transform: scale(1.05);
    }
`;

export const BubleWhite = styled.div`
    width: 20px;
    height: 20px;
    top: -2px;
    right: -2px;
    z-index: 2;
    background: ${({ theme }) => theme.colors.card.background};
    border: 2px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
`;

export const WhiteWrapper = styled.div`
    width: 24px;
    height: 24px;
    top: -2px;
    right: -2px;
    z-index: 2;
    background: ${({ theme }) => theme.colors.card.background};
    border: 2px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
`;

export const BubleBlack = styled.div`
    width: 20px;
    height: 20px;
    top: -2px;
    right: -2px;
    z-index: 2;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#fff' : '#1a1d1f')};
    border: 2px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 5;
`;

export const SkeletonOverlay = styled.div<{ height?: string }>`
    position: absolute;
    inset: 0;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
    background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(90deg, #374151 25%, #4b5563 50%, #374151 75%)'
    : 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)')};
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;

    @keyframes shimmer {
        from { background-position: -200% 0; }
        to { background-position: 200% 0; }
    }
`;

export const DropdownMenuStyled = styled.div`
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 4px 16px rgba(255, 255, 255, 0.08)'
    : '0 4px 16px rgba(224, 123, 45, 0.15)')};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    padding: 6px;
    min-width: 160px;
`;
